import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { CustomText } from "../../../components/CustomText";

import { GetAuthorById } from "../../../api/api.service";
import { useRequestProcessor } from "../../../hooks/useRequestProcessors";
import { getKey, MODULE_KEYS } from "../../../api/api.keys";
import { hasData, truncateString } from "../../../utils/commonUtils";
import { LoaderFallbackUI } from "../../../components/LoaderFallbackUI";
import GoalStatus from "../../../constants/GoalStatus";
import { SummaryCard } from "../../../components/SummaryCard";
import APP_CONFIG from "../../../APP_CONFIG";
import { APP_ROUTES, getParamsAttachedRoute } from "../../../helpers/routeHelpers";

const CHARACTER_LIMIT = 30;

const AuthorDetails = () => {
    const location = useLocation();
    const history = useHistory();

    const id = location.pathname.split("/").pop();

    let { useFetch } = useRequestProcessor();
    const { data, isLoading, isFetching } = useFetch(
        getKey([MODULE_KEYS.AUTHOR_DETAILS], { id }),
        async ({ signal }) =>
            await GetAuthorById({
                id
            })
    );

    if (isFetching || isLoading || !hasData(data)) {
        return (
            <div style={{ height: "70vh" }}>
                <LoaderFallbackUI isLoader={isFetching} className={"h-100"} />
            </div>
        );
    }

    return (
        <Container fluid className="p-4 goal-detail-container ">
            <Row className="mb-2 d-flex align-items-center gap-2">
                <Col lg={2} xs={5} sm={3}>
                    <img
                        src={
                            `${data?.image?.location}${
                                data?.image?.path || data?.image?.thumbPath
                            }` || APP_CONFIG.IMAGES.AVATAR_PLACEHOLDER
                        }
                        // src={data?.image?.thumbPath || APP_CONFIG.IMAGES.AVATAR_PLACEHOLDER}
                        alt={"Thumbnail"}
                        className="author-display"
                    />
                </Col>
                <Col lg={3} xs={5} sm={3}>
                    <CustomText
                        title={"Author Name"}
                        // description={data?.name || "-"}
                        description={
                            (
                                <div className="data-container">
                                    <div data-container={data?.name}>
                                        {truncateString(data?.name, CHARACTER_LIMIT) || "-"}
                                    </div>
                                </div>
                            ) || "-"
                        }
                        titleClass="label-classes"
                        descClass="desc-classes"
                    />
                </Col>
                <Col lg={3} xs={5} sm={3}>
                    <CustomText
                        title={"Degree"}
                        description={
                            (
                                <div className="data-container">
                                    <div data-container={data?.degree}>
                                        {truncateString(data?.degree, CHARACTER_LIMIT) || "-"}
                                    </div>
                                </div>
                            ) || "-"
                        }
                        titleClass="label-classes"
                        descClass="desc-classes"
                    />
                </Col>
                <Col lg={3} xs={5} sm={3}>
                    <CustomText
                        title={"License"}
                        description={
                            (
                                <div className="data-container">
                                    <div data-container={data?.license}>
                                        {truncateString(data?.license, CHARACTER_LIMIT) || "-"}
                                    </div>
                                </div>
                            ) || "-"
                        }
                        titleClass="label-classes"
                        descClass="desc-classes"
                    />
                </Col>
            </Row>
            <Row className="mt-4">
                <Col lg={2} xs={5} sm={3}>
                    <CustomText
                        titleClass="label-classes"
                        descClass={`  ${
                            data?.status ? "status-common-class" : ""
                        } ${GoalStatus.getLabelClass(data?.status)}`}
                        title={"Status"}
                        description={GoalStatus.getDisplayTextKey(data?.status) || "N/A"}
                    />
                </Col>
            </Row>

            {data?.about ? (
                <Row className="mb-2 session-container mt-2 py-4">
                    <Col xs={12} className="session-heading">
                        About Author
                    </Col>
                    <p className="about-data">{data?.about}</p>
                </Row>
            ) : null}
            {data?.album?.length ? (
                <Row className="mb-2 session-container">
                    <Col xs={12} className="session-heading">
                        Linked Audios
                    </Col>
                    <div className="narrator-audio">
                        {/*  */}
                        {data?.album?.map((album) => {
                            return (
                                <div
                                    className="narrator-audio-container"
                                    onClick={() =>
                                        history.push(
                                            getParamsAttachedRoute(
                                                APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SERIES_DETAILS,
                                                {
                                                    seriesID: album?.id
                                                }
                                            )
                                        )
                                    }
                                >
                                    <div className="narrator-audio-container-img">
                                        <img
                                            src={
                                                `${album?.thumbnail?.location}${
                                                    album?.thumbnail?.thumbPath ||
                                                    album?.thumbnail?.path
                                                }` || APP_CONFIG.IMAGES.AVATAR_PLACEHOLDER
                                            }
                                            alt={album?.thumbnail?.name || "Thumbnail"}
                                            className="narrator-audio-container-img-thumbnail"
                                        />
                                    </div>
                                    <div className="narrator-audio-container-details">
                                        <span className="narrator-audio-container-details-name">
                                            {album?.title || "-"}
                                        </span>
                                    </div>
                                </div>
                                // <Col md={2} className="py-2">

                                // </Col>
                            );
                        })}
                    </div>
                </Row>
            ) : null}
        </Container>
    );
};

export default AuthorDetails;
